import { render, staticRenderFns } from "./CtintMainTab.vue?vue&type=template&id=f80e513e&"
import script from "./CtintMainTab.vue?vue&type=script&lang=js&"
export * from "./CtintMainTab.vue?vue&type=script&lang=js&"
import style0 from "./CtintMainTab.vue?vue&type=style&index=0&id=f80e513e&prod&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports